export const registrationQuery = `
 mutation Register($input: RegisterCompanyInput!) {
      register(input: $input) {
        code
        companyId
        userId
        companyStatus
        adminStatus
        storeId
        storeStatus
    }
 }
`;
